/* Shop the look: één product of de hele set toevoegen via /cart/add.js, daarna opent de
   winkelwagenlade van het theme (ajaxCart.load met de side-cart section uit de response) */
if (!customElements.get('ts-shop-the-look')) {
    customElements.define('ts-shop-the-look', class extends HTMLElement {
        connectedCallback() {
            if (this.initialized) return;
            this.initialized = true;

            this.addEventListener('click', (e) => {
                const single = e.target.closest('[data-ts-add]');
                const set = e.target.closest('[data-ts-add-set]');
                if (single) this.add([single.closest('[data-ts-item]')], single);
                if (set) this.add([...this.querySelectorAll('[data-ts-item]')], set);
            });

            this.addEventListener('change', (e) => {
                const select = e.target.closest('select[data-ts-variant]');
                if (!select) return;
                select.classList.remove('is-invalid');
                const option = select.selectedOptions[0];
                const price = select.closest('[data-ts-item]').querySelector('[data-ts-price]');
                if (price && option && option.dataset.price) price.textContent = option.dataset.price;
            });
        }

        async add(rows, button) {
            const items = [];
            const missing = [];
            rows.forEach((row) => {
                const input = row.querySelector('[data-ts-variant]');
                if (!input) return; /* uitverkocht product: niet in de set */
                if (!input.value) missing.push(input);
                else items.push({ id: Number(input.value), quantity: 1 });
            });

            if (missing.length) {
                missing.forEach((el) => el.classList.add('is-invalid'));
                missing[0].focus();
                this.alert(this.dataset.errorSize);
                return;
            }
            if (!items.length) return;

            button.setAttribute('aria-busy', 'true');
            try {
                const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ items, sections: 'side-cart' })
                });
                const data = await res.json();
                if (!res.ok || data.status) {
                    this.alert(data.description || data.message);
                    return;
                }
                if (window.ajaxCart && typeof window.ajaxCart.load === 'function' && data.sections) {
                    window.ajaxCart.load(data);
                } else {
                    window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
                }
            } catch (err) {
                console.error('ts-shop-the-look', err);
            } finally {
                button.removeAttribute('aria-busy');
            }
        }

        /* Zelfde melding als het theme bij fouten in de winkelwagen */
        alert(message) {
            if (!message) return;
            window.dispatchEvent(new CustomEvent('showAlert', { detail: { message, type: 'error' } }));
        }
    });
}
